import React, { useState, useEffect, useRef } from 'react';
import { View, StyleSheet, Platform, ActivityIndicator } from 'react-native';
import * as Haptics from 'expo-haptics';
import { MainButton } from '../buttons/MainButton';
import theme from '../../constants/theme.style.js';
import CustomText from '../customText/CustomText';
import TextField from '../textField/TextField';
import AuthFooter from '../authFooter/AuthFooter';

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
  info: {
    fontFamily: 'Nunito_Bold',
    fontSize: theme.FONT_SIZE_HEADLINE,
    textAlign: 'center',
    color: theme.GREEN_WARM_COLOR,
    marginBottom: 10,
  },
  loading: {
    marginTop: 5,
    marginBottom: 10,
    padding: 2,
  },
});

const LoginForm = ({
  onLogin,
  currentUser,
  callback,
  info,
  navigateToMainApp,
  navigateToDataDeclaration,
}) => {
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [loginError, setLoginError] = useState(false);
  const [loading, setLoading] = useState(false);
  const passwordRef = useRef();

  useEffect(() => {
    if (Object.keys(currentUser).length !== 0 && currentUser.success !== false) {
      navigateToMainApp();
    }
  });

  const login = async () => {
    setLoading(true);
    if (Platform.OS !== 'web') Haptics.notificationAsync();
    const result = await onLogin({ username, password });
    setLoading(false);

    if (!result.user) setLoginError(true);
  };

  return (
    <View style={styles.container}>
      {info !== '' && <CustomText style={styles.info}>{info}</CustomText>}

      <TextField
        label="Username"
        value={username}
        error={loginError}
        onChangeText={(value) => setUsername(value)}
        returnKeyType="next"
        onSubmitEditing={() => passwordRef.current?.focus()}
      />
      <TextField
        ref={passwordRef}
        label="Password"
        secureTextEntry
        value={password}
        error={loginError && 'Password or Username incorrect'}
        onChangeText={(value) => setPassword(value)}
        returnKeyType="send"
        onSubmitEditing={login}
      />

      {loading ? (
        <ActivityIndicator style={styles.loading} color={theme.PRIMARY_COLOR} size="large" />
      ) : (
        <MainButton
          title="Login"
          btnBgColor={theme.GREEN_DARKER_COLOR}
          textColor={theme.WHITE_COLOR}
          btnTextSize={15}
          btnWidth={200}
          btnPadding="5%"
          btnMarginTop={5}
          btnMarginBottom={10}
          btnPress={login}
          testID="loginButton"
        />
      )}

      <AuthFooter
        question="Don't have an account?"
        linkTitle="Sign Up here"
        onClick={callback}
        navigateToDataDeclaration={navigateToDataDeclaration}
      />
    </View>
  );
};

export default LoginForm;
